import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid rgba(33, 33, 33, 0.12);
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
`;
